import { render, staticRenderFns } from "./vue-file-icon.vue?vue&type=template&id=61d49b70&"
import script from "./vue-file-icon.vue?vue&type=script&lang=ts&"
export * from "./vue-file-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports